import { render, staticRenderFns } from "./BeeLabel.vue?vue&type=template&id=74ba3d02&"
import script from "./BeeLabel.vue?vue&type=script&lang=js&"
export * from "./BeeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports